'use client';

import {
  CircularProgress,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { useBannerSort } from '~/entities/Banners/hooks';
import {
  stickNameCell,
  StyledHeaderBoxTableCell,
  StyledHeaderTableCell,
  StyledTable,
} from '~/shared';
import SortIcon from '~/shared/icons/SortIcon';
import { CampaignBannerReport } from '~/types';

import { useGetReportsCampaign } from '../../hooks';

import { ReportCampaignRow } from './Row';

export type ReportCampaignListProps = {
  getReportsCampaignQuery: ReturnType<typeof useGetReportsCampaign>;
  advertiserId: string;
  campaignId: string;
  // campaignName?: string;
};

export function ReportCampaignList({
  getReportsCampaignQuery,
  advertiserId,
  campaignId,
  // campaignName,
}: ReportCampaignListProps) {
  const { data, isLoading, isError, error } = getReportsCampaignQuery;

  const {
    sortedBanners: sortedReports,
    sortByOrderName,
    sortByOrderImpressions,
    sortByOrderClicks,
    sortByOrderCTR,
    sortByOrderCPM,
    sortByOrderCPC,
    setSortByOrderName,
    setSortByOrderImpressions,
    setSortByOrderClicks,
    setSortByOrderCTR,
    setSortByOrderCPM,
    setSortByOrderCPC,
    toggleSort,
  } = useBannerSort(data?.list);

  return (
    <StyledTable aria-label="Tabela de Relatórios">
      <TableHead>
        <TableRow>
          <StyledHeaderTableCell sx={stickNameCell()}>
            <StyledHeaderBoxTableCell>
              <Typography variant="body2" component="p" fontWeight={500}>
                Nome / Formato
              </Typography>
              <SortIcon
                sortOrder={sortByOrderName}
                onClick={() => toggleSort(sortByOrderName, setSortByOrderName)}
              />
            </StyledHeaderBoxTableCell>
          </StyledHeaderTableCell>
          <StyledHeaderTableCell>Plataforma</StyledHeaderTableCell>
          <StyledHeaderTableCell>
            <StyledHeaderBoxTableCell>
              <Typography variant="body2" component="p" fontWeight={500}>
                Impressões
              </Typography>
              <SortIcon
                sortOrder={sortByOrderImpressions}
                onClick={() =>
                  toggleSort(sortByOrderImpressions, setSortByOrderImpressions)
                }
              />
            </StyledHeaderBoxTableCell>
          </StyledHeaderTableCell>
          <StyledHeaderTableCell>
            <StyledHeaderBoxTableCell>
              <Typography variant="body2" component="p" fontWeight={500}>
                Cliques
              </Typography>
              <SortIcon
                sortOrder={sortByOrderClicks}
                onClick={() =>
                  toggleSort(sortByOrderClicks, setSortByOrderClicks)
                }
              />
            </StyledHeaderBoxTableCell>
          </StyledHeaderTableCell>
          <StyledHeaderTableCell>
            <StyledHeaderBoxTableCell>
              <Typography variant="body2" component="p" fontWeight={500}>
                CTR
              </Typography>
              <SortIcon
                sortOrder={sortByOrderCTR}
                onClick={() => toggleSort(sortByOrderCTR, setSortByOrderCTR)}
              />
            </StyledHeaderBoxTableCell>
          </StyledHeaderTableCell>
          <StyledHeaderTableCell>
            <StyledHeaderBoxTableCell>
              <Typography variant="body2" component="p" fontWeight={500}>
                CPM
              </Typography>
              <SortIcon
                sortOrder={sortByOrderCPM}
                onClick={() => toggleSort(sortByOrderCPM, setSortByOrderCPM)}
              />
            </StyledHeaderBoxTableCell>
          </StyledHeaderTableCell>
          <StyledHeaderTableCell>
            <StyledHeaderBoxTableCell>
              <Typography variant="body2" component="p" fontWeight={500}>
                CPC
              </Typography>
              <SortIcon
                sortOrder={sortByOrderCPC}
                onClick={() => toggleSort(sortByOrderCPC, setSortByOrderCPC)}
              />
            </StyledHeaderBoxTableCell>
          </StyledHeaderTableCell>
          {/* <StyledHeaderTableCell align="center">Download</StyledHeaderTableCell> */}
        </TableRow>
      </TableHead>

      <TableBody>
        {isLoading && (
          <TableRow>
            <TableCell component="th" scope="row" colSpan={8} align="center">
              <CircularProgress size={15} /> Carregando
            </TableCell>
          </TableRow>
        )}

        {!isLoading && !isError && sortedReports?.length === 0 && (
          <TableRow>
            <TableCell colSpan={8} align="center">
              Sem resultados
            </TableCell>
          </TableRow>
        )}

        {isError && (
          <TableRow>
            <TableCell
              sx={{ color: theme => theme.palette.error.light }}
              colSpan={8}
              align="center"
            >
              <Typography>Ocorreu um erro: {error.name}</Typography>
              <Typography>{error.message}</Typography>
            </TableCell>
          </TableRow>
        )}

        {!isLoading &&
          !isError &&
          sortedReports?.map((resume: CampaignBannerReport) => {
            return (
              <ReportCampaignRow
                key={resume.name}
                resume={resume}
                advertiserId={advertiserId}
                campaignId={campaignId}
                // campaignName={campaignName}
              />
            );
          })}
      </TableBody>
    </StyledTable>
  );
}
